"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentCatalogue = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useTranslations = require("../../../hooks/useTranslations");
var _common = require("../../common");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CurrentCatalogue = props => {
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    onClick,
    isMobile,
    catalogue: {
      url,
      title,
      imageUrl,
      validity
    },
    linkToAllCatalogues
  } = props;
  if (isMobile) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.MobileWrapper, {
      "data-testid": getTestId(_common.MOBILE_CATALOGUE),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Banner, {
        type: "catalogue",
        dateRange: validity ?? '',
        title: title ?? '',
        imageUrl: imageUrl ?? undefined,
        url: url ?? undefined
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CatalogueLink, {
        hoverEffect: true,
        "data-testid": getTestId(_common.LINK),
        href: linkToAllCatalogues ?? undefined,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CTAText, {
          variant: "subtitle1",
          "data-testid": getTestId(_common.CTA_TEXT),
          children: translations.seeAll
        })
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Catalogue, {
    "data-testid": getTestId(_common.DESKTOP_CATALOGUE),
    onClick: onClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CategoryBox, {
      title: title,
      imageUrl: imageUrl,
      description: validity,
      relativeUrl: url ?? '',
      buttonText: translations.view
    }, title)
  });
};
exports.CurrentCatalogue = CurrentCatalogue;
